var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectboxreceive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.66663V6.66663M10.0002 6.66663L11.6668 4.99996M10.0002 6.66663L8.3335 4.99996",
    stroke: "#558AF0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10V6.6667C4.16667 4.9917 4.16667 3.60837 6.66667 3.3667M15.8333 10V6.6667C15.8333 4.9917 15.8333 3.60837 13.3333 3.3667M5.83333 10C2.5 10 2.5 11.4917 2.5 13.3334V14.1667C2.5 16.4667 2.5 18.3334 6.66667 18.3334H13.3333C16.6667 18.3334 17.5 16.4667 17.5 14.1667V13.3334C17.5 11.4917 17.5 10 14.1667 10C13.3333 10 13.1 10.175 12.6667 10.5L11.8167 11.4C11.583 11.6486 11.3009 11.8467 10.9877 11.9821C10.6746 12.1175 10.337 12.1874 9.99583 12.1874C9.65466 12.1874 9.3171 12.1175 9.00395 11.9821C8.6908 11.8467 8.40869 11.6486 8.175 11.4L7.33333 10.5C6.9 10.175 6.66667 10 5.83333 10Z",
    stroke: "#558AF0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectboxreceive);
export default __webpack_public_path__ + "static/media/directboxreceive.f25448736556b59c4a0c10c412f01985.svg";
export { ForwardRef as ReactComponent };